import { render, staticRenderFns } from "./IndicatorEvolutionPill.vue?vue&type=template&id=7ea2ac96&scoped=true&"
import script from "./IndicatorEvolutionPill.vue?vue&type=script&lang=js&"
export * from "./IndicatorEvolutionPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea2ac96",
  null
  
)

export default component.exports